export default __webpack_public_path__ + "static/media/Tap-Tap.71d04538.gif";